import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowsClockwise, X } from "@phosphor-icons/react";

export default function PWAUpdateBanner() {
  const [reg, setReg] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => setReg(e.detail?.registration || null);
    window.addEventListener("sw-update-available", handler);
    return () => window.removeEventListener("sw-update-available", handler);
  }, []);

  if (!reg || dismissed) return null;

  const update = () => {
    try {
      const w = reg.waiting || reg.installing;
      if (w) w.postMessage({ type: "SKIP_WAITING" });
      // Fallback if no active worker to message
      setTimeout(() => window.location.reload(), 1500);
    } catch {
      window.location.reload();
    }
  };

  return (
    <div
      data-testid="pwa-update-banner"
      className="sticky top-0 z-[60] w-full bg-gradient-to-r from-blue-700 via-blue-600 to-blue-800 text-white shadow-md"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-6 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <ArrowsClockwise size={20} weight="bold" className="shrink-0 animate-spin-slow" />
          <p className="text-sm font-semibold truncate">
            Nova versão disponível — atualize para ver as novidades
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            data-testid="btn-pwa-update"
            size="sm"
            onClick={update}
            className="bg-white text-blue-800 hover:bg-blue-50 hover:text-blue-900 font-bold h-8"
          >
            Atualizar
          </Button>
          <button
            data-testid="btn-pwa-update-dismiss"
            aria-label="Dispensar"
            onClick={() => setDismissed(true)}
            className="text-white/80 hover:text-white p-1"
          >
            <X size={16} weight="bold" />
          </button>
        </div>
      </div>
    </div>
  );
}
